import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

import BodyText from 'components/Luxkit/Typography/BodyText'

const OrContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr min-content 1fr;
  gap: ${rem(12)};
  align-items: center;
`

const OrLine = styled.div`
  height: 1px;
  width: 100%;
  background-color: ${(props) => props.theme.palette.neutral.five};
`

function SearchOrSeparator() {
  return (
    <OrContainer>
      <OrLine />
      <BodyText variant="large" colour="neutral-two">
        or
      </BodyText>
      <OrLine />
    </OrContainer>
  )
}

export default SearchOrSeparator
